import { ConfigProvider, Layout, Modal, Select } from "antd";
import "../billing.scss";
import RetractionRequestGridHandler from "./RetractionRequestGridHandler";
import { useEffect } from "react";


const ApproveRetractionRequest = () => {  
  
    useEffect(() => {
        document.title = "Approve Retraction Request";  // ← This sets the browser tab title
    }, []);

    return (
      <ConfigProvider theme={{
        components: {
            Layout: { bodyBg: "#eff1f5", siderBg: "#fff" }
        }
    }} >
      <Layout style={{
            padding: '20px',
            marginBottom: '5px',
            marginTop: '5px',            
        }}>
          <h3 style={{ textTransform: 'uppercase', marginTop:'0px' }}>Approve Retraction Request</h3>
          <RetractionRequestGridHandler ratype='2' />
        </Layout>
    </ConfigProvider>
    );
};

export default ApproveRetractionRequest;